import type { UseInfiniteQueryResult } from '@tanstack/react-query'
import type { ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'

import { Button } from '@/src/elements/button/default'
import { ICON } from '@/src/general/enums/icons'

type TCommunitiesLoadMoreButtonProps = Pick<
  UseInfiniteQueryResult,
  'isFetchingNextPage' | 'hasNextPage' | 'fetchNextPage'
> & {
  data?: unknown[]
}

export const CommunitiesLoadMoreButton = ({
  data,
  hasNextPage,
  isFetchingNextPage,
  fetchNextPage,
}: TCommunitiesLoadMoreButtonProps): ReactNode =>
  data &&
  hasNextPage && (
    <Button
      isLoading={isFetchingNextPage}
      className="mt-8 bg-none"
      variant="light"
      colors="default"
      startIcon={ICON.SEARCH}
      onPress={() => {
        if (!isFetchingNextPage) fetchNextPage()
      }}
    >
      <FormattedMessage id="communities.see-more" />
    </Button>
  )
